import {DigitalPageItem} from '../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: 'Hello!',
  ProductCode: 'eahs44',
  Description:
    'Here&#39;s all the online content included with your <strong>English Language &amp; Literature Complete Revision &amp; Practice</strong>',
  Credits:
    '<p><em>Assessment objective wording licensed under the Open Government Licence. </em><a href="https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/"><em>https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/</em></a>\n' +
    '&nbsp;\n' +
    '<em>Clipart from Corel &reg;</em><br />\n' +
    '&nbsp;\n' +
    '<em>This RevisionHub does not include any official AQA questions and is not endorsed by AQA.</em><br />\n' +
    '&nbsp;\n' +
    '<em>Text, design, layout and original illustrations &copy; Coordination Group Publications Ltd. (CGP) 2025. All rights reserved.</em></p>\n',
};
